import { __awaiter, __generator, __assign } from 'tslib';
import { uaTool, videoTool, commonTool, KeySystems, HDR_CAPABILITY, jsonTool, cookieTool, convertCookieStr2Object, urlTool } from '@tencent/thumbplayer-utils';

function getRefer() {
    var refer = '';
    try {
        refer = removeUrlParams(document.location.href);
        if (isInIframe()) {
            refer = removeUrlParams(document.referrer || '');
        }
    }
    catch (e) { }
    return refer;
}
function removeUrlParams(url) {
    if (typeof url !== 'string')
        return;
    var link = document.createElement('a');
    link.href = url;
    return "".concat(link.protocol, "//").concat(link.host).concat(link.pathname);
}
function getEhost() {
    var ehost = '';
    try {
        ehost = location.href.replace(location.search, '');
        if (isInIframe()) {
            ehost = removeUrlParams(top.location.href || '');
        }
    }
    catch (e) { }
    return ehost;
}
function isInIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
function getSpHttps() {
    return location.protocol === 'https:' ? 1 : 0;
}
function getTimeStampStr(value) {
    var len = value || 10;
    var timestamp = (+new Date()).toString();
    if (timestamp.length > len) {
        return timestamp.substring(0, len);
    }
    return "00000000000".concat(timestamp).slice(-1 * len);
}
function constructM3U8(url, baseUrl, m3u8) {
    return m3u8.replace(baseUrl, url);
}

/**
 * 请求vinfo时使用的drm能力参数
 *
 * @export
 * @enum {number}
 */
var DrmReqValue;
(function (DrmReqValue) {
    DrmReqValue[DrmReqValue["NONE"] = 0] = "NONE";
    DrmReqValue[DrmReqValue["FAIRPLAY"] = 16] = "FAIRPLAY";
    DrmReqValue[DrmReqValue["WIDEVINE"] = 32] = "WIDEVINE";
    DrmReqValue[DrmReqValue["CHACHA20"] = 8] = "CHACHA20";
    DrmReqValue[DrmReqValue["PLAYREADY"] = 256] = "PLAYREADY";
})(DrmReqValue || (DrmReqValue = {}));
/** 后台支持hevc等级的参数枚举（腾讯视频的点播和直播的hevclv字段是对齐的） */
var HevcLvValue;
(function (HevcLvValue) {
    // AUTO = void 0,
    HevcLvValue[HevcLvValue["NOT_SPT"] = 0] = "NOT_SPT";
    /** hevc标清（sd） */
    HevcLvValue[HevcLvValue["SD"] = 11] = "SD";
    /** hevc高清（hd） */
    HevcLvValue[HevcLvValue["HD"] = 16] = "HD";
    /** hevc超清（shd） */
    HevcLvValue[HevcLvValue["SHD"] = 21] = "SHD";
    /** hevc-蓝光（fhd） */
    HevcLvValue[HevcLvValue["FHD"] = 26] = "FHD";
    /** hevc 4k */
    HevcLvValue[HevcLvValue["UHD"] = 28] = "UHD";
    /** 只给hevc-uhd(无低清晰度hevc） */
    HevcLvValue[HevcLvValue["UHD_ONLY"] = 31] = "UHD_ONLY";
})(HevcLvValue || (HevcLvValue = {}));
/**
 * 后台支持的 O266 清晰度档位
 */
var O266LvValue;
(function (O266LvValue) {
    O266LvValue[O266LvValue["NOT_SPT"] = 0] = "NOT_SPT";
    O266LvValue[O266LvValue["SD"] = 1] = "SD";
    O266LvValue[O266LvValue["HD"] = 3] = "HD";
    O266LvValue[O266LvValue["SHD"] = 7] = "SHD";
})(O266LvValue || (O266LvValue = {}));
/**
 * 请求腾讯视频点播的流类型（dtype字段）
 */
var ReqVodStreamType;
(function (ReqVodStreamType) {
    ReqVodStreamType[ReqVodStreamType["MP4"] = 1] = "MP4";
    ReqVodStreamType[ReqVodStreamType["HLS"] = 3] = "HLS";
    /** 直出m3u8请求类型 */
    ReqVodStreamType[ReqVodStreamType["DIR_HLS"] = 8] = "DIR_HLS";
})(ReqVodStreamType || (ReqVodStreamType = {}));
var CkeyVer;
(function (CkeyVer) {
    CkeyVer["CKEY_8"] = "8.5";
    CkeyVer["CKEY_9"] = "9.1";
})(CkeyVer || (CkeyVer = {}));
/** 付费清晰度列表 */
var PaidFormat;
(function (PaidFormat) {
    /** 1080p */
    PaidFormat["FHD"] = "fhd";
    /** 4k */
    PaidFormat["UHD"] = "uhd";
    /** 杜比视界 */
    PaidFormat["DOLBY"] = "dolby";
    /** 臻彩视界 */
    PaidFormat["HDR10"] = "hdr10";
    /** 臻彩视听 */
    PaidFormat["SFR_HDR"] = "sfr_hdr";
})(PaidFormat || (PaidFormat = {}));
var LoginMethod;
(function (LoginMethod) {
    LoginMethod["QQ"] = "qq";
    LoginMethod["WX"] = "wx";
})(LoginMethod || (LoginMethod = {}));
var CookieName;
(function (CookieName) {
    CookieName["MAIN_LOGIN"] = "main_login";
    CookieName["GUID"] = "video_guid";
    CookieName["OPENID"] = "openid";
    CookieName["APPID"] = "appid";
    CookieName["VUSERID"] = "vuserid";
    CookieName["ACCESS_TOKEN"] = "access_token";
    CookieName["VUSESSION"] = "vusession";
})(CookieName || (CookieName = {}));
var VQQ_COOKIE_PREFIX = 'vqq_';
var PlayerCookie;
(function (PlayerCookie) {
    PlayerCookie["DEFN_VOD"] = "player_defn_vod";
    PlayerCookie["SPTS"] = "player_spts";
    /** 广告rfid */
    PlayerCookie["AD_RFID"] = "player_rfid";
})(PlayerCookie || (PlayerCookie = {}));

/**
 * 拼接在浏览器端的默认请求参数
 */
function getTxVodBrowserDefaultReqParams() {
    return {
        charge: 0,
        otype: 'json',
        defnpayver: 0,
        spau: 1,
        spaudio: 1,
        spwm: 1,
        sphls: 1,
        host: location.host,
        refer: getRefer(),
        ehost: getEhost(),
        sphttps: getSpHttps(),
        encryptVer: '',
        cKey: '',
        clip: 4,
        guid: '',
        flowid: '',
        platform: '',
        sdtfrom: '',
        appVer: '1.0.0.0',
        unid: '',
        auth_from: '',
        auth_ext: '',
        vid: '',
        defn: '',
        fhdswitch: 0,
        dtype: ReqVodStreamType.HLS,
        spsrt: 2,
        tm: '',
        lang_code: 0,
        logintoken: '',
    };
}

var localDRMCache = DrmReqValue.NONE;
/** 获取用于腾讯视频播控的DRM参数 */
function getDrmParam(prefer) {
    return __awaiter(this, void 0, void 0, function () {
        var res, _a, playreadyHW, widevine;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (typeof prefer !== 'undefined') {
                        // 优先使用指定的drm参数
                        return [2 /*return*/, prefer];
                    }
                    if (localDRMCache) {
                        return [2 /*return*/, localDRMCache];
                    }
                    res = DrmReqValue.NONE;
                    /** 移动端跳过 */
                    if (uaTool.mobile)
                        return [2 /*return*/, res];
                    /** 支持wasm的情况下可以使用chacha */
                    if (window.WebAssembly)
                        res |= DrmReqValue.CHACHA20;
                    if (!uaTool.browser.chrome) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all([
                            videoTool.isEncryptionSupported(KeySystems.PlayReadyHardware),
                            videoTool.isEncryptionSupported(KeySystems.Widevine),
                        ])];
                case 1:
                    _a = _b.sent(), playreadyHW = _a[0], widevine = _a[1];
                    if (playreadyHW) {
                        res |= DrmReqValue.PLAYREADY;
                    }
                    if (widevine
                        && commonTool.compareVersion(uaTool.browser.chrome.version, '89.0') > 0) {
                        res |= DrmReqValue.WIDEVINE;
                    }
                    localDRMCache = res;
                    return [3 /*break*/, 3];
                case 2:
                    if (uaTool.browser.safari
                        && videoTool.supportFairplay()) {
                        res |= DrmReqValue.FAIRPLAY;
                        localDRMCache = res;
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/, res];
            }
        });
    });
}

/**
 * 生成付费请求的getvinfo请求参数集
 *
 * @export
 * @param {PAID_FORMAT[]} formats
 * @returns {RequestParams} 请求参数集
 */
function getPaidFormatParam(formats, capConf) {
    if (!capConf) {
        capConf = {
            isSptHevc: videoTool.supportHevc(),
            hdr: videoTool.isHDRSupported(),
            isSptDolbyAtoms: videoTool.isDolbyAtomsSupported(),
            isSptDolbyVision: videoTool.isDolbyVisionSupported(),
        };
    }
    var payFormatParam = {
        spsfrhdr: 0,
        spvideo: 0,
        spaudio: 0,
        defnpayver: 0,
    };
    if (formats.indexOf(PaidFormat.FHD) > -1) {
        payFormatParam.defnpayver |= 0x1;
    }
    if (formats.indexOf(PaidFormat.UHD) > -1) {
        payFormatParam.defnpayver |= 0x2;
    }
    if (capConf.isSptHevc && capConf.hdr === HDR_CAPABILITY.SUPPORTED) {
        // HDR10 & HDR vivid（臻彩视界)
        if (formats.indexOf(PaidFormat.HDR10) > -1) {
            payFormatParam.spvideo |= 0x404; // hdr 10 0x4 + hdr vivid 0x400
            payFormatParam.defnpayver |= 0x4;
        }
        if (formats.indexOf(PaidFormat.SFR_HDR) > -1) {
            payFormatParam.spvideo |= 0x404; // hdr 10 0x4 + hdr vivid 0x400
            payFormatParam.spaudio |= 0x40;
            payFormatParam.spsfrhdr = 100;
            payFormatParam.defnpayver |= 0x4;
        }
        if (formats.indexOf(PaidFormat.DOLBY) > -1
            && capConf.isSptDolbyAtoms
            && capConf.isSptDolbyVision) {
            payFormatParam.spaudio |= 0x6; // dolby surround + dolby atoms
            payFormatParam.spvideo |= 0x10; // 注意这里只支持fmp4容器
            payFormatParam.defnpayver |= 0x4; // 0x4会默认添加1080p支持，需要端实现1080p付费
        }
    }
    return payFormatParam;
}
/**
 * 生成直播付费请求的请求参数集
 *
 * @export
 * @param {PAID_FORMAT[]} formats
 * @returns {LiveRequestParam} 请求参数集
 */
function getPaidFormatParamForLive(formats) {
    var param = {
        spvideo: 0,
    };
    if (videoTool.supportHevc()
        && videoTool.isHDRSupported() === HDR_CAPABILITY.SUPPORTED
        && formats.indexOf(PaidFormat.HDR10) > -1) { // HDR vivid
        param.spvideo |= 0x4;
    }
    return param;
}

/**
 * 腾讯视频登录态参数
 */
function getLogintoken(outCookieMap) {
    var userCookies = getUserCookies(void 0, outCookieMap);
    var logintoken = Object.keys(userCookies).length > 0 ? jsonTool.safelyStringify(userCookies) : '';
    return { logintoken: logintoken };
}
/**
 * 给到广告后台的腾讯视频登录态参数
 */
function getLogintoken4Ad(outCookieMap) {
    var _a;
    return getUserCookies((_a = {},
        _a[CookieName.MAIN_LOGIN] = 'lt',
        _a[CookieName.OPENID] = 'opid',
        _a[CookieName.APPID] = 'appid',
        _a[CookieName.ACCESS_TOKEN] = 'atkn',
        _a[CookieName.VUSERID] = 'uid',
        _a[CookieName.VUSESSION] = 'tkn',
        _a), outCookieMap);
}
/**
 * 获取当前页面登陆态信息
 *
 * @export
 * @param {?Record<COOKIE_NAME, string>} [transforms]
 * 替换返回的参数名。如提供，则只返回声明部分的cookie。transform的格式为{[origin cookie name]: [new cookie name]}
 * @returns {Object} cookies字典
 */
function getUserCookies(transforms, outCookieMap) {
    var _a;
    var _b, _c, _d, _e, _f, _g;
    var cookieMap = outCookieMap || cookieTool.get();
    var loginType = cookieMap[CookieName.MAIN_LOGIN];
    if (!loginType)
        return {};
    var needVQQPrefix = loginType === LoginMethod.QQ;
    var cookies = (_a = {},
        // 以下5个token根据登陆态不同，需要取不同名称的cookie
        _a[CookieName.ACCESS_TOKEN] = (_b = getCookieWithPrefix(cookieMap, CookieName.ACCESS_TOKEN, needVQQPrefix)) !== null && _b !== void 0 ? _b : '',
        _a[CookieName.APPID] = (_c = getCookieWithPrefix(cookieMap, CookieName.APPID, needVQQPrefix)) !== null && _c !== void 0 ? _c : '',
        _a[CookieName.VUSESSION] = (_d = getCookieWithPrefix(cookieMap, CookieName.VUSESSION, needVQQPrefix)) !== null && _d !== void 0 ? _d : '',
        _a[CookieName.OPENID] = (_e = getCookieWithPrefix(cookieMap, CookieName.OPENID, needVQQPrefix)) !== null && _e !== void 0 ? _e : '',
        _a[CookieName.VUSERID] = (_f = getCookieWithPrefix(cookieMap, CookieName.VUSERID, needVQQPrefix)) !== null && _f !== void 0 ? _f : '',
        // 静态，无需区分登陆类型
        _a[CookieName.GUID] = (_g = cookieMap[CookieName.GUID]) !== null && _g !== void 0 ? _g : '',
        _a[CookieName.MAIN_LOGIN] = loginType,
        _a);
    // 校验登陆态是否合法
    if (validateCookie(cookies)) {
        // 如果有传入指定的transform，只返回对应的cookie
        if (transforms) {
            return Object.keys(transforms).reduce(function (acc, cur) {
                var newName = transforms[cur];
                acc[newName] = cookies[cur];
                return acc;
            }, {});
        }
        return cookies;
    }
    return {};
}
/** 获取指定前缀的cookie */
function getCookieWithPrefix(cookieMap, name, needPrefix) {
    if (needPrefix === void 0) { needPrefix = false; }
    return cookieMap[needPrefix ? "".concat(VQQ_COOKIE_PREFIX).concat(name) : name];
}
/** 检查登陆态cookie是否合法 */
function validateCookie(cookies) {
    /** 如果没有main login，则所有的登陆态不合法 */
    if (!cookies[CookieName.MAIN_LOGIN])
        return false;
    /** 旧有逻辑，qq登陆态需要vuid和access token */
    if (cookies[CookieName.MAIN_LOGIN] === LoginMethod.QQ) {
        if (!cookies[CookieName.VUSERID] || !cookies[CookieName.ACCESS_TOKEN]) {
            return false;
        }
    }
    return true;
}

/**
 * 获取getinfo的请求参数spadseg值，用于告诉后台是否支持hls中插、videoIn广告能力。
 */
function getSptAdSegParam(adPluginInstalled) {
    // 0x1:支持植入广告(videoin)
    // 0x2:支持中插广告(hls标版，dis标签)
    // 0x3都支持
    if (adPluginInstalled && videoTool.supportMSE()) {
        return { spadseg: 0x3 }; // 支持hls内核的情况下，我们支持标版和videoin
    }
    return { spadseg: 0 };
}
function getDtypeParam(capConf) {
    if (!capConf) {
        capConf = {
            isSptMse: videoTool.supportMSE(),
            isSptOriginHls: videoTool.supportVideoFormat().includes('hls'),
        };
    }
    // 支持mse或原生支持hls，请求dtype=3
    if (capConf.isSptMse || capConf.isSptOriginHls) {
        return { dtype: ReqVodStreamType.HLS };
    }
    return { dtype: ReqVodStreamType.MP4 };
}
/**
 * 主要拼接m3u8相关参数，这些参数和master m3u8代理直出及中插广告相关。
 */
function getM3u8Param(capConf, uaModel) {
    if (!capConf) {
        capConf = {
            isSptMse: videoTool.supportMSE(),
        };
    }
    if (!uaModel) {
        uaModel = uaTool;
    }
    var param = {
        spm3u8tag: 0x40 | 0x01 | 0x02,
        spmasterm3u8: 0x3,
        sphls: 1,
    };
    // 普通m3u8直出
    if (!uaModel.mobile && capConf.isSptMse) {
        param.sphls = 2;
    }
    return param;
}

/**
 * 获取请求后台hevclv的参数。例如请求直播后台，需要使用hevclv参数指定返回265流。
 * @returns 返回为{ hevclv: number }
 */
function getHevcLevelParam(config) {
    var _a = config.hevcGPUBlackList, hevcGPUBlackList = _a === void 0 ? {} : _a, _b = config.supportedPaidFormat, supportedPaidFormat = _b === void 0 ? [] : _b, isSupportedWasmHevcOnTx = config.isSupportedWasmHevcOnTx, isForceDisableHevc = config.isForceDisableHevc;
    // gpu黑名单
    var blacklistedBrowser = Object.keys(hevcGPUBlackList);
    var gpuInfo = videoTool.collectGPUInfo();
    var isBlacklisted = false;
    // 检查所有的browser UA是否包含黑名单信息，这里有个问题，属于uatool的先天性问题。如果配置了chrome，edge也会被误伤
    blacklistedBrowser.forEach(function (browser) {
        if (gpuInfo
            && checkBrowserCondition(browser)
            && hevcGPUBlackList[browser].some(function (i) { return gpuInfo.renderer.match(new RegExp(i, 'i')); })) {
            isBlacklisted = true;
        }
    });
    // 强行关闭
    if (isForceDisableHevc || isBlacklisted) {
        return null;
    }
    // 当前原生支持hevc编码
    if (videoTool.supportHevc() // 浏览器原生hevc支持判断
        && (uaTool.mobile ? shouldEnableHEVCOnMobile() : true) // 移动端需要判断是否开启hevc
    ) {
        if (supportedPaidFormat.indexOf(PaidFormat.UHD) !== -1) {
            // 使用hls内核播放4k视频
            return { hevclv: HevcLvValue.UHD };
        }
        return { hevclv: HevcLvValue.FHD };
    }
    // 使用wasm内核播放hevc视频
    if (isSupportedWasmHevcOnTx) {
        // 播放器配置中默认启用腾讯视频hevc的情况：
        // 如果是请求的自动清晰度或者请求的低码率清晰度，返回hevc-level到高清
        return { hevclv: HevcLvValue.HD };
    }
    // 不支持hevc播放
    return null;
}
/**
 * 判断配置 / 环境是否支持 O266 编码，并返回对应请求参数
 */
function getSptO266Param(config) {
    return __awaiter(this, void 0, void 0, function () {
        var isVod, enableO266, isEnvSupport, supportHWA, isPlaybackSupport, batterySupport, _a, level, charging;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isVod = config.isVod, enableO266 = config.enableO266;
                    isEnvSupport = videoTool.supportO266();
                    supportHWA = videoTool.isHardwareAccelerated();
                    isPlaybackSupport = isVod && enableO266 && isEnvSupport && supportHWA;
                    // 上述都是同步的判断，执行快，后续有一个异步 await，这里先提前判断一波降低耗时
                    if (!isPlaybackSupport) {
                        return [2 /*return*/, null];
                    }
                    batterySupport = true;
                    if (!(typeof navigator.getBattery === 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, navigator.getBattery()];
                case 1:
                    _a = _b.sent(), level = _a.level, charging = _a.charging;
                    // 要求插电，或者离电时电量大于 60% 才调度 O266
                    batterySupport = charging || level >= 0.6;
                    _b.label = 2;
                case 2:
                    if (isPlaybackSupport && batterySupport) {
                        return [2 /*return*/, {
                                spvvc: O266LvValue.HD,
                            }];
                    }
                    // 电量过低，不开 266
                    return [2 /*return*/, null];
            }
        });
    });
}
/**
 * 判断当前环境是否支持AV1编码并添加相应请求参数。
 */
function getSptAv1Param() {
    var isChromiumEdge = uaTool.browser.edg && uaTool.browser.chrome;
    if (videoTool.supportAV1()) {
        // chromium edg下调用设备av1解码器需要开启硬件加速
        if (isChromiumEdge && !videoTool.isHardwareAccelerated())
            return null;
        // https://tapd.woa.com/qqvideo_prj/markdown_wikis/show/#1210114481001146481
        // 15表示sd-fhd均支持av1
        return { spav1: 15 };
    }
    return null;
}
function shouldEnableHEVCOnMobile() {
    var browser = uaTool.browser;
    var allowedUA = [
        'xweb',
        'x5',
    ];
    return allowedUA.some(function (ua) { return browser[ua]; });
}
/**
 * 解析ua判断参数是否命中
 *
 * @param {string} condition 格式为 <browser>[<operator><version>] 如 edg>118 或!chrome=119
 * @returns {boolean} 当前的UA是否符合判断条件
 */
function checkBrowserCondition(condition) {
    var isNegative = condition.startsWith('!');
    var negRemoved = isNegative ? condition.slice(1) : condition;
    // match[1] is the browser name
    // match[2] is the operator
    // match[3] is the version
    var match = negRemoved.match(/^(\w+)(?:([=<>])(\d+))?/);
    if (!match || !uaTool.browser[match[1]])
        return false; // match不存在或uatool不存在对应的browser，直接返回未命中
    if (!match[2] || !match[3])
        return !!uaTool.browser[match[1]]; // 没有操作符或者版本号，直接返回是否存在目标browser
    try {
        var versionCompare = commonTool.compareVersion(uaTool.browser[match[1]].version, match[3]);
        var res = false;
        switch (match[2]) {
            case '<':
                res = versionCompare < 0;
                break;
            case '>':
                res = versionCompare > 0;
                break;
            case '=':
                res = versionCompare === 0;
                break;
            default:
                return res;
        }
        return isNegative ? !res : res;
    }
    catch (_a) {
        return false;
    }
}

var cachedCapabilityConfig = null;
/**
 * 获取所有跟请求字段相关的设备能力配置
 */
function getAllCapabilityConfig() {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!cachedCapabilityConfig) return [3 /*break*/, 2];
                    _a = {
                        isSptHevc: videoTool.supportHevc(),
                        hdr: videoTool.isHDRSupported(),
                        isSptDolbyAtoms: videoTool.isDolbyAtomsSupported(),
                        isSptDolbyVision: videoTool.isDolbyVisionSupported(),
                        isSptMse: videoTool.supportMSE(),
                        isSptOriginHls: videoTool.supportVideoFormat().includes('hls')
                    };
                    return [4 /*yield*/, getDrmParam(undefined)];
                case 1:
                    cachedCapabilityConfig = (_a.drmValue = _b.sent(),
                        _a);
                    _b.label = 2;
                case 2: return [2 /*return*/, cachedCapabilityConfig];
            }
        });
    });
}
/**
 * 把能力值转成字符串，每一位都代表一个能力值，用|隔开。例如转成‘32|true|false’
 * （注意: 能力值类型只有boolean和数字）
 */
function convertCapabilityConfig2String(capConfig) {
    // keys按UTF-16排序，保证每次存储的都是同一个顺序
    var keys = Object.keys(ALL_CAPABILITY_CONFIG).sort();
    var capConfigStr = keys
        .map(function (key) { return (typeof capConfig[key] === 'undefined' ? '' : "".concat(capConfig[key])); })
        .join('|');
    return capConfigStr;
}
/**
 * 把字符串转成能力值配置
 */
function convertString2CapabilityConfig(str) {
    if (!str) {
        return {};
    }
    var keys = Object.keys(ALL_CAPABILITY_CONFIG).sort();
    var capConfigArr = str.split('|');
    var capConfig = {};
    for (var i = 0; i < keys.length; i++) {
        if (capConfigArr[i] === '') {
            continue;
        }
        if (capConfigArr[i] === 'true' || capConfigArr[i] === 'false') {
            capConfig[keys[i]] = capConfigArr[i] === 'true';
        }
        else {
            var val = +capConfigArr[i];
            if (!isNaN(val)) {
                capConfig[keys[i]] = val;
            }
        }
    }
    return capConfig;
}
var ALL_CAPABILITY_CONFIG = {
    isSptMse: false,
    isSptHevc: false,
    isSptOriginHls: false,
    drmValue: DrmReqValue.NONE,
    hdr: HDR_CAPABILITY.NOT_SUPPORTED,
    isSptDolbyAtoms: false,
    isSptDolbyVision: false,
};

/**
 * 直播请求流类型
 */
var LiveStreamType;
(function (LiveStreamType) {
    LiveStreamType[LiveStreamType["AUTO"] = 0] = "AUTO";
    LiveStreamType[LiveStreamType["FLV"] = 1] = "FLV";
    LiveStreamType[LiveStreamType["HLS"] = 2] = "HLS";
    LiveStreamType[LiveStreamType["RTMP"] = 4] = "RTMP";
    LiveStreamType[LiveStreamType["DASH"] = 8] = "DASH";
    LiveStreamType[LiveStreamType["WEB_RTC"] = 16] = "WEB_RTC";
    LiveStreamType[LiveStreamType["T_RTC"] = 32] = "T_RTC";
})(LiveStreamType || (LiveStreamType = {}));

// 请求协议https://trpc.rick.woa.com/rick/pb/view_protobuf?id=20554
function getTxLiveBrowserDefaultReqParams() {
    return {
        defnswitch: 0,
        flowid: '',
        cmd: 2,
        roomid: '',
        anchorid: 0,
        pid: '',
        chid: '',
        defn: 'auto',
        ufps: 'auto',
        playbacktime: 0,
        ckey: '',
        appver: '1.0.0.0',
        encrypt_ver: '',
        uin: '',
        country_code: 0,
        lang_code: 0,
        guid: '',
        appid: 0,
        platform: '',
        // livedrm: 0, //  这里不能给默认值了，因为getRequestParamForDRM函数会判断typeof livedrm === 'undefined'
        playbackdrm: 0,
        // 个人直播中，支持mse场景的非移动端场景，请求flv+hls，否则只请求hls
        format_support: (videoTool.supportMSE() && !uaTool.mobile) ? LiveStreamType.FLV | LiveStreamType.HLS : LiveStreamType.HLS,
        caplv: 0,
        hevclv: 0,
        net_type: 0,
        bandwidth: 0,
        sphttps: getSpHttps(),
        unicomtype: 0,
        unicom: '',
        telcom: '',
        cmcc: '',
        toushe: 0,
        from_platform: 0,
        tm: '',
        scene: '',
        spaudio: 0,
        spvideo: 0,
        atmos: 0,
        sdclive_info: '',
        cnlid: '',
        host: location.host,
        sdtfrom: '',
    };
}

// @ts-nocheck
var Qvsec = {};
Qvsec.ha = (function (clss) {
    var k = [];
    var i = 0;
    for (; i < 64;) {
        k[i] = 0 | (Math.abs(Math.sin(++i)) * 4294967296);
    }
    function add(x, y) {
        return (((x >> 1) + (y >> 1)) << 1) + (x & 1) + (y & 1);
    }
    var calcSHA = function (str) {
        var b;
        var c;
        var d;
        var j;
        var x = [];
        var str2 = unescape(encodeURI(str));
        var a = str2.length;
        var h = [b = 1732584193, c = -271733879, ~b, ~c];
        var i = 0;
        for (; i <= a;)
            x[i >> 2] |= (str2.charCodeAt(i) || 128) << 8 * (i++ % 4);
        x[str = (a + 8 >> 6) * clss + 14] = a * 8;
        i = 0;
        for (; i < str; i += clss) {
            a = h,
                j = 0;
            for (; j < 64;) {
                a = [d = a[3], add(b = a[1], (d = add(add(a[0], [b & (c = a[2]) | ~b & d, d & b | ~d & c, b ^ c ^ d, c ^ (b | ~d)][a = j >> 4]), add(k[j], x[[j, 5 * j + 1, 3 * j + 5, 7 * j][a] % clss + i]))) << (a = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, clss, 23, 6, 10, 15, 21][4 * a + j++ % 4]) | d >>> 32 - a), b, c];
            }
            for (j = 4; j;)
                h[--j] = add(h[j], a[j]);
        }
        str = '';
        for (; j < 32;)
            str += ((h[j >> 3] >> ((1 ^ j++ & 7) * 4)) & 15).toString(clss);
        return str;
    };
    return calcSHA;
}(16));
Qvsec.stringToHex = function (s) {
    var r = '';
    var hexes = new Array('0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f');
    for (var i = 0; i < s.length; i++) {
        r += hexes[s.charCodeAt(i) >> 4] + hexes[s.charCodeAt(i) & 0xf];
    }
    return r;
};
Qvsec.hexToString = function (h) {
    var r = '';
    for (var i = (h.substr(0, 2) == '0x') ? 2 : 0; i < h.length; i += 2) {
        r += String.fromCharCode(parseInt(h.substr(i, 2), 16));
    }
    return r;
};
Qvsec._Seed = '#$#@#*ad';
Qvsec.tempcalc = function (a, b) {
    var r = '';
    for (var i = 0; i < a.length; i++)
        r += String.fromCharCode(a.charCodeAt(i) ^ b.charCodeAt(i % 4));
    return r;
};
Qvsec.u1 = function (a, b) {
    var r = '';
    for (var i = b; i < a.length; i += 2)
        r += a.charAt(i);
    return r;
};
Qvsec._urlStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
Qvsec.urlenc = function (input, sts, ts) {
    var output = '';
    var chr1;
    var chr2;
    var chr3;
    var enc1;
    var enc2;
    var enc3;
    var enc4;
    var i = 0;
    while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        if (i == 15) {
            output = "".concat(output, "A");
            output = output + sts;
            output = output + ts;
        }
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        }
        else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output = output +
            Qvsec._urlStr.charAt(enc1) + Qvsec._urlStr.charAt(enc2) +
            Qvsec._urlStr.charAt(enc3) + Qvsec._urlStr.charAt(enc4);
    }
    return output;
};
Qvsec.$xx = function (plt, vid, std, sts, ts, encver) {
    var magic = '123456';
    if (encver.length < 3)
        return 'err';
    if ('7.' != encver.substr(0, 2))
        return 'err';
    var subver = encver.substr(2);
    if ('1' == subver)
        magic = '06fc1464';
    if ('2' == subver)
        magic = '4244ce1b';
    if ('3' == subver)
        magic = '77de31c5';
    if ('4' == subver)
        magic = 'e0149fa2';
    if ('5' == subver)
        magic = '60394ced';
    if ('6' == subver)
        magic = '2da639f0';
    if ('7' == subver)
        magic = 'c2f0cf9f';
    var ts = ts || parseInt(+new Date / 1e3);
    var result = Qvsec.ha("".concat(magic + vid + ts, "*#06#").concat(plt));
    return result;
};

//@ts-nocheck
var Zu = Z1;
(function (Z2, Z3) { var ZR = Z1, Z4 = Z2(); while (!![]) {
    try {
        var Z5 = parseInt(ZR(0x1fc)) / 0x1 + -parseInt(ZR(0x1fe)) / 0x2 * (-parseInt(ZR(0x278)) / 0x3) + parseInt(ZR(0x205)) / 0x4 + -parseInt(ZR(0x251)) / 0x5 * (-parseInt(ZR(0x281)) / 0x6) + parseInt(ZR(0x1f6)) / 0x7 + -parseInt(ZR(0x247)) / 0x8 + -parseInt(ZR(0x1ff)) / 0x9;
        if (Z5 === Z3)
            break;
        else
            Z4['push'](Z4['shift']());
    }
    catch (Z6) {
        Z4['push'](Z4['shift']());
    }
} }(Z0, 0x8de7b));
var t, r, e, n, o, i, s = function (Z2, Z3) { return s = Object['setProt' + 'otypeOf'] || { '__proto__': [] } instanceof Array && function (Z4, Z5) { var Zc = Z1; Z4[Zc(0x218) + '__'] = Z5; } || function (Z4, Z5) { var ZA = Z1; for (var Z6 in Z5)
    Object[ZA(0x24d) + 'pe'][ZA(0x249) + ZA(0x231)][ZA(0x270)](Z5, Z6) && (Z4[Z6] = Z5[Z6]); }, s(Z2, Z3); };
function c(Z2, Z3) { var ZF = Z1; if ('functio' + 'n' != typeof Z3 && null !== Z3)
    throw new TypeError('Class\x20e' + ZF(0x252) + 'value\x20' + String(Z3) + (ZF(0x243) + '\x20a\x20cons' + 'tructor' + ZF(0x25a) + 'l')); function Z4() { var Zy = ZF; this[Zy(0x228) + Zy(0x22b)] = Z2; } s(Z2, Z3), Z2[ZF(0x24d) + 'pe'] = null === Z3 ? Object['create'](Z3) : (Z4['prototy' + 'pe'] = Z3['prototy' + 'pe'], new Z4()); }
'functio' + 'n' == typeof SuppressedError && SuppressedError, (null === (t = Zu(0x27a) + 'ed' != typeof globalThis ? globalThis : void 0x0) || void 0x0 === t ? void 0x0 : t[Zu(0x203)]) || (null === (r = Zu(0x27a) + 'ed' != typeof global ? global : void 0x0) || void 0x0 === r ? void 0x0 : r['crypto']) || (null === (e = Zu(0x27a) + 'ed' != typeof window ? window : void 0x0) || void 0x0 === e ? void 0x0 : e[Zu(0x203)]) || (null === (n = Zu(0x27a) + 'ed' != typeof self ? self : void 0x0) || void 0x0 === n ? void 0x0 : n['crypto']) || null === (i = null === (o = Zu(0x27a) + 'ed' != typeof frames ? frames : void 0x0) || void 0x0 === o ? void 0x0 : o[0x0]) || void 0x0 === i || i[Zu(0x203)];
for (var a = function (Z2) { for (var Z3 = [], Z4 = function (Z8) { var Z9 = Z8, ZZ = 0x3ade68b1, Zp = 0xffffffff; return function () { var Zr = ((ZZ = 0x9069 * (0xffff & ZZ) + (ZZ >> 0x10) & Zp) << 0x10) + (Z9 = 0x4650 * (0xffff & Z9) + (Z9 >> 0x10) & Zp) & Zp; return Zr /= 0x100000000, (Zr += 0.5) * (Math['random']() > 0.5 ? 0x1 : -0x1); }; }, Z5 = 0x0, Z6 = void 0x0; Z5 < Z2; Z5 += 0x4) {
    var Z7 = Z4(0x100000000 * (Z6 || Math['random']()));
    Z6 = 0x3ade67b7 * Z7(), Z3['push'](0x100000000 * Z7() | 0x0);
} return new p(Z3, Z2); }, u = (function () { var ZL = Zu; function Z2() { } return Z2['create'] = function () { var Zs = Z1; for (var Z3 = [], Z4 = 0x0; Z4 < arguments[Zs(0x224)]; Z4++)
    Z3[Z4] = arguments[Z4]; return new (this['bind']['apply'](this, function (Z5, Z6, Z7) { var ZH = Zs; if (Z7 || 0x2 === arguments[ZH(0x224)]) {
    for (var Z8, Z9 = 0x0, ZZ = Z6[ZH(0x224)]; Z9 < ZZ; Z9++)
        !Z8 && Z9 in Z6 || (Z8 || (Z8 = Array[ZH(0x24d) + 'pe'][ZH(0x23a)][ZH(0x270)](Z6, 0x0, Z9)), Z8[Z9] = Z6[Z9]);
} return Z5[ZH(0x214)](Z8 || Array[ZH(0x24d) + 'pe'][ZH(0x23a)][ZH(0x270)](Z6)); }([void 0x0], Z3, !0x1)))(); }, Z2[ZL(0x24d) + 'pe'][ZL(0x25c)] = function (Z3) { var ZO = ZL; return Object[ZO(0x26f)](this, Z3); }, Z2[ZL(0x24d) + 'pe'][ZL(0x20b)] = function () { var Zz = ZL, Z3 = new this[(Zz(0x228)) + (Zz(0x22b))](); return Object[Zz(0x26f)](Z3, this), Z3; }, Z2; }()), p = function (Z2) { var Zb = Zu; function Z3(Z4, Z5) { var Ze = Z1; void 0x0 === Z4 && (Z4 = []), void 0x0 === Z5 && (Z5 = 0x4 * Z4['length']); var Z6 = Z2[Ze(0x270)](this) || this, Z7 = Z4; if (Z7 instanceof ArrayBuffer && (Z7 = new Uint8Array(Z7)), ArrayBuffer[Ze(0x253)](Z7) && (Z7 = new Uint8Array(Z7[Ze(0x279)], Z7[Ze(0x221) + Ze(0x1fd)], Z7[Ze(0x20f) + Ze(0x1f9)])), Z7 instanceof Uint8Array) {
    for (var Z8 = Z7[Ze(0x20f) + 'gth'], Z9 = [], ZZ = 0x0; ZZ < Z8; ZZ += 0x1)
        Z9[ZZ >>> 0x2] |= Z7[ZZ] << 0x18 - ZZ % 0x4 * 0x8;
    Z6[Ze(0x232)] = Z9, Z6[Ze(0x264) + 's'] = Z8;
}
else
    Z6['words'] = Z4, Z6['sigByte' + 's'] = Z5; return Z6; } return c(Z3, Z2), Z3['prototy' + 'pe'][Zb(0x255) + 'g'] = function (Z4) { var ZD = Zb; return void 0x0 === Z4 && (Z4 = f), Z4[ZD(0x237) + 'fy'](this); }, Z3['prototy' + 'pe'][Zb(0x214)] = function (Z4) { var Zg = Zb, Z5 = this[Zg(0x232)], Z6 = Z4[Zg(0x232)], Z7 = this[Zg(0x264) + 's'], Z8 = Z4[Zg(0x264) + 's']; if (this[Zg(0x208)](), Z7 % 0x4)
    for (var Z9 = 0x0; Z9 < Z8; Z9 += 0x1) {
        var ZZ = Z6[Z9 >>> 0x2] >>> 0x18 - Z9 % 0x4 * 0x8 & 0xff;
        Z5[Z7 + Z9 >>> 0x2] |= ZZ << 0x18 - (Z7 + Z9) % 0x4 * 0x8;
    }
else {
    for (Z9 = 0x0; Z9 < Z8; Z9 += 0x4)
        Z5[Z7 + Z9 >>> 0x2] = Z6[Z9 >>> 0x2];
} return this[Zg(0x264) + 's'] += Z8, this; }, Z3[Zb(0x24d) + 'pe']['clamp'] = function () { var ZE = Zb, Z4 = this['words'], Z5 = this[ZE(0x264) + 's']; Z4[Z5 >>> 0x2] &= 0xffffffff << 0x20 - Z5 % 0x4 * 0x8, Z4[ZE(0x224)] = Math[ZE(0x225)](Z5 / 0x4); }, Z3[Zb(0x24d) + 'pe'][Zb(0x20b)] = function () { var Zd = Zb, Z4 = Z2[Zd(0x24d) + 'pe'][Zd(0x20b)][Zd(0x270)](this); return Z4[Zd(0x232)] = this[Zd(0x232)][Zd(0x23a)](0x0), Z4; }, Z3[Zb(0x233)] = a, Z3; }(u), f = { 'stringify': function (Z2) { var ZI = Zu; for (var Z3 = Z2['words'], Z4 = Z2[ZI(0x264) + 's'], Z5 = [], Z6 = 0x0; Z6 < Z4; Z6 += 0x1) {
        var Z7 = Z3[Z6 >>> 0x2] >>> 0x18 - Z6 % 0x4 * 0x8 & 0xff;
        Z5[ZI(0x26d)]((Z7 >>> 0x4)[ZI(0x255) + 'g'](0x10)), Z5['push']((0xf & Z7)[ZI(0x255) + 'g'](0x10));
    } return Z5[ZI(0x20c)](''); }, 'parse': function (Z2) { var ZM = Zu; for (var Z3 = Z2[ZM(0x224)], Z4 = [], Z5 = 0x0; Z5 < Z3; Z5 += 0x2)
        Z4[Z5 >>> 0x3] |= parseInt(Z2[ZM(0x27c)](Z5, 0x2), 0x10) << 0x18 - Z5 % 0x8 * 0x4; return new p(Z4, Z3 / 0x2); } }, h = function (Z2) { var ZQ = Zu; for (var Z3 = Z2[ZQ(0x224)], Z4 = [], Z5 = 0x0; Z5 < Z3; Z5 += 0x1)
    Z4[Z5 >>> 0x2] |= (0xff & Z2['charCod' + 'eAt'](Z5)) << 0x18 - Z5 % 0x4 * 0x8; return new p(Z4, Z3); }, l = function (Z2) { return h(unescape(encodeURIComponent(Z2))); }, v = function (Z2) { var Zh = Zu; function Z3() { var ZS = Z1, Z4 = Z2[ZS(0x270)](this) || this; return Z4[ZS(0x22f) + ZS(0x259)] = 0x0, Z4; } return c(Z3, Z2), Z3['prototy' + 'pe']['reset'] = function () { var Zx = Z1; this[Zx(0x272)] = new p(), this[Zx(0x246) + Zx(0x244)] = 0x0; }, Z3[Zh(0x24d) + 'pe'][Zh(0x216)] = function (Z4) { var ZP = Zh, Z5 = Z4; ZP(0x220) == typeof Z5 && (Z5 = l(Z5)), this[ZP(0x272)][ZP(0x214)](Z5), this[ZP(0x246) + ZP(0x244)] += Z5['sigByte' + 's']; }, Z3[Zh(0x24d) + 'pe'][Zh(0x271) + 's'] = function (Z4) { var ZU = Zh, Z5, Z6 = this[ZU(0x272)], Z7 = this[ZU(0x20d) + 'ze'], Z8 = Z6['words'], Z9 = Z6[ZU(0x264) + 's'], ZZ = Z9 / (0x4 * Z7), Zp = (ZZ = Z4 ? Math[ZU(0x225)](ZZ) : Math[ZU(0x285)]((0x0 | ZZ) - this[ZU(0x22f) + ZU(0x259)], 0x0)) * Z7, Zr = Math[ZU(0x287)](0x4 * Zp, Z9); if (Zp) {
    for (var Zm = 0x0; Zm < Zp; Zm += Z7)
        this[ZU(0x229) + 'essBloc' + 'k'](Z8, Zm);
    Z5 = Z8[ZU(0x1f8)](0x0, Zp), Z6[ZU(0x264) + 's'] -= Zr;
} return new p(Z5, Zr); }, Z3['prototy' + 'pe']['clone'] = function () { var Zq = Zh, Z4 = Z2[Zq(0x24d) + 'pe']['clone'][Zq(0x270)](this); return Z4[Zq(0x272)] = this[Zq(0x272)]['clone'](), Z4; }, Z3; }(u), y = function (Z2) { var ZT = Zu; function Z3(Z4) { var ZK = Z1, Z5 = Z2['call'](this) || this; return Z5[ZK(0x20d) + 'ze'] = 0x10, Z5[ZK(0x267)] = Object[ZK(0x26f)](new u(), Z4), Z5[ZK(0x282)](), Z5; } return c(Z3, Z2), Z3[ZT(0x201) + ZT(0x23b)] = function (Z4) { return function (Z5, Z6) { var Zw = Z1; return new Z4(Z6)[Zw(0x284) + 'e'](Z5); }; }, Z3['prototy' + 'pe']['reset'] = function () { var ZY = ZT; Z2[ZY(0x24d) + 'pe'][ZY(0x282)]['call'](this), this[ZY(0x238) + 't'](); }, Z3[ZT(0x24d) + 'pe'][ZT(0x25d)] = function (Z4) { var ZN = ZT; return this['_append'](Z4), this[ZN(0x271) + 's'](), this; }, Z3[ZT(0x24d) + 'pe']['finaliz' + 'e'] = function (Z4) { var p0 = ZT; return Z4 && this[p0(0x216)](Z4), this[p0(0x24b) + p0(0x262)](); }, Z3; }(v), d = [], _ = 0x0; _ < 0x40; _ += 0x1)
    d[_] = 0x100000000 * Math['abs'](Math[Zu(0x21b)](_ + 0x1)) | 0x0;
var g = function (Z2, Z3, Z4, Z5, Z6, Z7, Z8) { var Z9 = Z2 + (Z3 & Z4 | ~Z3 & Z5) + Z6 + Z8; return (Z9 << Z7 | Z9 >>> 0x20 - Z7) + Z3; }, w = function (Z2, Z3, Z4, Z5, Z6, Z7, Z8) { var Z9 = Z2 + (Z3 & Z5 | Z4 & ~Z5) + Z6 + Z8; return (Z9 << Z7 | Z9 >>> 0x20 - Z7) + Z3; }, B = function (Z2, Z3, Z4, Z5, Z6, Z7, Z8) { var Z9 = Z2 + (Z3 ^ Z4 ^ Z5) + Z6 + Z8; return (Z9 << Z7 | Z9 >>> 0x20 - Z7) + Z3; }, m = function (Z2, Z3, Z4, Z5, Z6, Z7, Z8) { var Z9 = Z2 + (Z4 ^ (Z3 | ~Z5)) + Z6 + Z8; return (Z9 << Z7 | Z9 >>> 0x20 - Z7) + Z3; }, k = function (Z2) { var p2 = Zu; function Z3() { var p1 = Z1; return null !== Z2 && Z2[p1(0x22c)](this, arguments) || this; } return c(Z3, Z2), Z3[p2(0x24d) + 'pe'][p2(0x238) + 't'] = function () { var p3 = p2; this[p3(0x219)] = new p([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476]); }, Z3['prototy' + 'pe'][p2(0x229) + p2(0x212) + 'k'] = function (Z4, Z5) { var p4 = p2; for (var Z6 = Z4, Z7 = 0x0; Z7 < 0x10; Z7 += 0x1) {
    var Z8 = Z5 + Z7, Z9 = Z4[Z8];
    Z6[Z8] = 0xff00ff & (Z9 << 0x8 | Z9 >>> 0x18) | 0xff00ff00 & (Z9 << 0x18 | Z9 >>> 0x8);
} var ZZ = this[p4(0x219)][p4(0x232)], Zp = Z6[Z5 + 0x0], Zr = Z6[Z5 + 0x1], Zm = Z6[Z5 + 0x2], Zl = Z6[Z5 + 0x3], ZB = Z6[Z5 + 0x4], Zf = Z6[Z5 + 0x5], Zi = Z6[Z5 + 0x6], ZJ = Z6[Z5 + 0x7], Za = Z6[Z5 + 0x8], ZW = Z6[Z5 + 0x9], Zo = Z6[Z5 + 0xa], Zv = Z6[Z5 + 0xb], Zn = Z6[Z5 + 0xc], Zt = Z6[Z5 + 0xd], ZV = Z6[Z5 + 0xe], ZC = Z6[Z5 + 0xf], ZG = ZZ[0x0], ZX = ZZ[0x1], Zk = ZZ[0x2], Zj = ZZ[0x3]; ZG = g(ZG, ZX, Zk, Zj, Zp, 0x7, d[0x0]), Zj = g(Zj, ZG, ZX, Zk, Zr, 0xc, d[0x1]), Zk = g(Zk, Zj, ZG, ZX, Zm, 0x11, d[0x2]), ZX = g(ZX, Zk, Zj, ZG, Zl, 0x16, d[0x3]), ZG = g(ZG, ZX, Zk, Zj, ZB, 0x7, d[0x4]), Zj = g(Zj, ZG, ZX, Zk, Zf, 0xc, d[0x5]), Zk = g(Zk, Zj, ZG, ZX, Zi, 0x11, d[0x6]), ZX = g(ZX, Zk, Zj, ZG, ZJ, 0x16, d[0x7]), ZG = g(ZG, ZX, Zk, Zj, Za, 0x7, d[0x8]), Zj = g(Zj, ZG, ZX, Zk, ZW, 0xc, d[0x9]), Zk = g(Zk, Zj, ZG, ZX, Zo, 0x11, d[0xa]), ZX = g(ZX, Zk, Zj, ZG, Zv, 0x16, d[0xb]), ZG = g(ZG, ZX, Zk, Zj, Zn, 0x7, d[0xc]), Zj = g(Zj, ZG, ZX, Zk, Zt, 0xc, d[0xd]), Zk = g(Zk, Zj, ZG, ZX, ZV, 0x11, d[0xe]), ZX = g(ZX, Zk, Zj, ZG, ZC, 0x16, d[0xf]), ZG = w(ZG, ZX, Zk, Zj, Zr, 0x5, d[0x10]), Zj = w(Zj, ZG, ZX, Zk, Zi, 0x9, d[0x11]), Zk = w(Zk, Zj, ZG, ZX, Zv, 0xe, d[0x12]), ZX = w(ZX, Zk, Zj, ZG, Zp, 0x14, d[0x13]), ZG = w(ZG, ZX, Zk, Zj, Zf, 0x5, d[0x14]), Zj = w(Zj, ZG, ZX, Zk, Zo, 0x9, d[0x15]), Zk = w(Zk, Zj, ZG, ZX, ZC, 0xe, d[0x16]), ZX = w(ZX, Zk, Zj, ZG, ZB, 0x14, d[0x17]), ZG = w(ZG, ZX, Zk, Zj, ZW, 0x5, d[0x18]), Zj = w(Zj, ZG, ZX, Zk, ZV, 0x9, d[0x19]), Zk = w(Zk, Zj, ZG, ZX, Zl, 0xe, d[0x1a]), ZX = w(ZX, Zk, Zj, ZG, Za, 0x14, d[0x1b]), ZG = w(ZG, ZX, Zk, Zj, Zt, 0x5, d[0x1c]), Zj = w(Zj, ZG, ZX, Zk, Zm, 0x9, d[0x1d]), Zk = w(Zk, Zj, ZG, ZX, ZJ, 0xe, d[0x1e]), ZX = w(ZX, Zk, Zj, ZG, Zn, 0x14, d[0x1f]), ZG = B(ZG, ZX, Zk, Zj, Zf, 0x4, d[0x20]), Zj = B(Zj, ZG, ZX, Zk, Za, 0xb, d[0x21]), Zk = B(Zk, Zj, ZG, ZX, Zv, 0x10, d[0x22]), ZX = B(ZX, Zk, Zj, ZG, ZV, 0x17, d[0x23]), ZG = B(ZG, ZX, Zk, Zj, Zr, 0x4, d[0x24]), Zj = B(Zj, ZG, ZX, Zk, ZB, 0xb, d[0x25]), Zk = B(Zk, Zj, ZG, ZX, ZJ, 0x10, d[0x26]), ZX = B(ZX, Zk, Zj, ZG, Zo, 0x17, d[0x27]), ZG = B(ZG, ZX, Zk, Zj, Zt, 0x4, d[0x28]), Zj = B(Zj, ZG, ZX, Zk, Zp, 0xb, d[0x29]), Zk = B(Zk, Zj, ZG, ZX, Zl, 0x10, d[0x2a]), ZX = B(ZX, Zk, Zj, ZG, Zi, 0x17, d[0x2b]), ZG = B(ZG, ZX, Zk, Zj, ZW, 0x4, d[0x2c]), Zj = B(Zj, ZG, ZX, Zk, Zn, 0xb, d[0x2d]), Zk = B(Zk, Zj, ZG, ZX, ZC, 0x10, d[0x2e]), ZX = B(ZX, Zk, Zj, ZG, Zm, 0x17, d[0x2f]), ZG = m(ZG, ZX, Zk, Zj, Zp, 0x6, d[0x30]), Zj = m(Zj, ZG, ZX, Zk, ZJ, 0xa, d[0x31]), Zk = m(Zk, Zj, ZG, ZX, ZV, 0xf, d[0x32]), ZX = m(ZX, Zk, Zj, ZG, Zf, 0x15, d[0x33]), ZG = m(ZG, ZX, Zk, Zj, Zn, 0x6, d[0x34]), Zj = m(Zj, ZG, ZX, Zk, Zl, 0xa, d[0x35]), Zk = m(Zk, Zj, ZG, ZX, Zo, 0xf, d[0x36]), ZX = m(ZX, Zk, Zj, ZG, Zr, 0x15, d[0x37]), ZG = m(ZG, ZX, Zk, Zj, Za, 0x6, d[0x38]), Zj = m(Zj, ZG, ZX, Zk, ZC, 0xa, d[0x39]), Zk = m(Zk, Zj, ZG, ZX, Zi, 0xf, d[0x3a]), ZX = m(ZX, Zk, Zj, ZG, Zt, 0x15, d[0x3b]), ZG = m(ZG, ZX, Zk, Zj, ZB, 0x6, d[0x3c]), Zj = m(Zj, ZG, ZX, Zk, Zv, 0xa, d[0x3d]), Zk = m(Zk, Zj, ZG, ZX, Zm, 0xf, d[0x3e]), ZX = m(ZX, Zk, Zj, ZG, ZW, 0x15, d[0x3f]), ZZ[0x0] = ZZ[0x0] + ZG | 0x0, ZZ[0x1] = ZZ[0x1] + ZX | 0x0, ZZ[0x2] = ZZ[0x2] + Zk | 0x0, ZZ[0x3] = ZZ[0x3] + Zj | 0x0; }, Z3['prototy' + 'pe'][p2(0x24b) + p2(0x262)] = function () { var p5 = p2, Z4 = this[p5(0x272)], Z5 = Z4[p5(0x232)], Z6 = 0x8 * this[p5(0x246) + p5(0x244)], Z7 = 0x8 * Z4['sigByte' + 's']; Z5[Z7 >>> 0x5] |= 0x80 << 0x18 - Z7 % 0x20; var Z8 = Math[p5(0x26a)](Z6 / 0x100000000), Z9 = Z6; Z5[0xf + (Z7 + 0x40 >>> 0x9 << 0x4)] = 0xff00ff & (Z8 << 0x8 | Z8 >>> 0x18) | 0xff00ff00 & (Z8 << 0x18 | Z8 >>> 0x8), Z5[0xe + (Z7 + 0x40 >>> 0x9 << 0x4)] = 0xff00ff & (Z9 << 0x8 | Z9 >>> 0x18) | 0xff00ff00 & (Z9 << 0x18 | Z9 >>> 0x8), Z4['sigByte' + 's'] = 0x4 * (Z5[p5(0x224)] + 0x1), this[p5(0x271) + 's'](); for (var ZZ = this[p5(0x219)], Zp = ZZ[p5(0x232)], Zr = 0x0; Zr < 0x4; Zr += 0x1) {
    var Zm = Zp[Zr];
    Zp[Zr] = 0xff00ff & (Zm << 0x8 | Zm >>> 0x18) | 0xff00ff00 & (Zm << 0x18 | Zm >>> 0x8);
} return ZZ; }, Z3[p2(0x24d) + 'pe']['clone'] = function () { var p6 = p2, Z4 = Z2[p6(0x24d) + 'pe'][p6(0x20b)][p6(0x270)](this); return Z4[p6(0x219)] = this[p6(0x219)]['clone'](), Z4; }, Z3; }(y), b = y[Zu(0x201) + Zu(0x23b)](k), S = { 'stringify': function (Z2) { var p7 = Zu, Z3 = Z2[p7(0x232)], Z4 = Z2[p7(0x264) + 's'], Z5 = this[p7(0x280)]; Z2['clamp'](); for (var Z6 = [], Z7 = 0x0; Z7 < Z4; Z7 += 0x3)
        for (var Z8 = (Z3[Z7 >>> 0x2] >>> 0x18 - Z7 % 0x4 * 0x8 & 0xff) << 0x10 | (Z3[Z7 + 0x1 >>> 0x2] >>> 0x18 - (Z7 + 0x1) % 0x4 * 0x8 & 0xff) << 0x8 | Z3[Z7 + 0x2 >>> 0x2] >>> 0x18 - (Z7 + 0x2) % 0x4 * 0x8 & 0xff, Z9 = 0x0; Z9 < 0x4 && Z7 + 0.75 * Z9 < Z4; Z9 += 0x1)
            Z6[p7(0x26d)](Z5['charAt'](Z8 >>> 0x6 * (0x3 - Z9) & 0x3f)); var ZZ = Z5['charAt'](0x40); if (ZZ) {
        for (; Z6[p7(0x224)] % 0x4;)
            Z6[p7(0x26d)](ZZ);
    } return Z6['join'](''); }, 'parse': function (Z2) { var p8 = Zu, Z3 = Z2[p8(0x224)], Z4 = this['_map'], Z5 = this[p8(0x217) + 'eMap']; if (!Z5) {
        this[p8(0x217) + p8(0x1f3)] = [], Z5 = this['_revers' + p8(0x1f3)];
        for (var Z6 = 0x0; Z6 < Z4[p8(0x224)]; Z6 += 0x1)
            Z5[Z4[p8(0x24c) + p8(0x242)](Z6)] = Z6;
    } var Z7 = Z4['charAt'](0x40); if (Z7) {
        var Z8 = Z2['indexOf'](Z7);
        -0x1 !== Z8 && (Z3 = Z8);
    } return function (Z9, ZZ, Zp) { var p9 = p8; for (var Zr = [], Zm = 0x0, Zl = 0x0; Zl < ZZ; Zl += 0x1)
        if (Zl % 0x4) {
            var ZB = Zp[Z9['charCod' + 'eAt'](Zl - 0x1)] << Zl % 0x4 * 0x2 | Zp[Z9[p9(0x24c) + p9(0x242)](Zl)] >>> 0x6 - Zl % 0x4 * 0x2;
            Zr[Zm >>> 0x2] |= ZB << 0x18 - Zm % 0x4 * 0x8, Zm += 0x1;
        } return p[p9(0x21d)](Zr, Zm); }(Z2, Z3, Z5); }, '_map': Zu(0x276) + Zu(0x275) + Zu(0x22a) + Zu(0x1f4) + 'cdefghi' + Zu(0x1f5) + 'qrstuvw' + 'xyz0123' + Zu(0x235) + '/=' }, O = function (Z2) { var pp = Zu; function Z3(Z4, Z5, Z6) { var pZ = Z1, Z7 = Z2[pZ(0x270)](this) || this; return Z7[pZ(0x267)] = Object['assign'](new u(), Z6), Z7['_xformM' + 'ode'] = Z4, Z7[pZ(0x207)] = Z5, Z7[pZ(0x282)](), Z7; } return c(Z3, Z2), Z3['createE' + pp(0x1fa) + 'r'] = function (Z4, Z5) { var pr = pp; return this[pr(0x21d)](this[pr(0x269) + pr(0x234) + 'E'], Z4, Z5); }, Z3[pp(0x241) + pp(0x25f) + 'r'] = function (Z4, Z5) { return this['create'](this['_DEC_XF' + 'ORM_MOD' + 'E'], Z4, Z5); }, Z3[pp(0x201) + 'Helper'] = function (Z4) { var Z5 = function (Z6) { return R; }; return { 'encrypt': function (Z6, Z7, Z8) { var pm = Z1; return Z5()[pm(0x21a)](Z4, Z6, Z7, Z8); }, 'decrypt': function (Z6, Z7, Z8) { var pl = Z1; return Z5()[pl(0x25b)](Z4, Z6, Z7, Z8); } }; }, Z3[pp(0x24d) + 'pe'][pp(0x282)] = function () { var pB = pp; Z2['prototy' + 'pe'][pB(0x282)][pB(0x270)](this), this[pB(0x238) + 't'](); }, Z3[pp(0x24d) + 'pe'][pp(0x1f7)] = function (Z4) { var pf = pp; return this[pf(0x216)](Z4), this[pf(0x271) + 's'](); }, Z3[pp(0x24d) + 'pe'][pp(0x284) + 'e'] = function (Z4) { var pi = pp; return Z4 && this[pi(0x216)](Z4), this[pi(0x24b) + pi(0x262)](); }, Z3; }(v);
function M(Z2, Z3, Z4) { var pJ = Zu, Z5, Z6 = Z2, Z7 = this[pJ(0x213)]; Z7 ? (Z5 = Z7, this['_iv'] = void 0x0) : Z5 = this['_prevBl' + pJ(0x211)]; for (var Z8 = 0x0; Z8 < Z4; Z8 += 0x1)
    Z6[Z3 + Z8] ^= Z5[Z8]; }
O[Zu(0x269) + Zu(0x234) + 'E'] = 0x1, O[Zu(0x21f) + Zu(0x234) + 'E'] = 0x2, O['keySize'] = 0x4, O['ivSize'] = 0x4;
var A = function (Z2) { function Z3() { return null !== Z2 && Z2['apply'](this, arguments) || this; } return c(Z3, Z2), Z3; }(function (Z2) { var pW = Zu; function Z3(Z4, Z5) { var pa = Z1, Z6 = Z2[pa(0x270)](this) || this; return Z6['_cipher'] = Z4, Z6[pa(0x213)] = Z5, Z6; } return c(Z3, Z2), Z3[pW(0x1f1) + pW(0x1fa) + 'r'] = function (Z4, Z5) { var po = pW; return this[po(0x26b) + 'or'][po(0x21d)](Z4, Z5); }, Z3['createD' + 'ecrypto' + 'r'] = function (Z4, Z5) { var pv = pW; return this[pv(0x254) + 'or']['create'](Z4, Z5); }, Z3; }(u));
A['Encrypt' + 'or'] = function (Z2) { var pt = Zu; function Z3() { var pn = Z1; return null !== Z2 && Z2[pn(0x22c)](this, arguments) || this; } return c(Z3, Z2), Z3[pt(0x24d) + 'pe'][pt(0x1f7) + pt(0x258)] = function (Z4, Z5) { var pV = pt, Z6 = this['_cipher'], Z7 = Z6[pV(0x20d) + 'ze']; M['call'](this, Z4, Z5, Z7), Z6[pV(0x21a) + pV(0x258)](Z4, Z5), this[pV(0x200) + pV(0x211)] = Z4[pV(0x23a)](Z5, Z5 + Z7); }, Z3; }(A), A[Zu(0x254) + 'or'] = function (Z2) { var pG = Zu; function Z3() { var pC = Z1; return null !== Z2 && Z2[pC(0x22c)](this, arguments) || this; } return c(Z3, Z2), Z3['prototy' + 'pe'][pG(0x1f7) + 'Block'] = function (Z4, Z5) { var pX = pG, Z6 = this[pX(0x24e)], Z7 = Z6[pX(0x20d) + 'ze'], Z8 = Z4[pX(0x23a)](Z5, Z5 + Z7); Z6[pX(0x25b) + pX(0x258)](Z4, Z5), M[pX(0x270)](this, Z4, Z5, Z7), this['_prevBl' + pX(0x211)] = Z8; }, Z3; }(A);
var z = { 'pad': function (Z2, Z3) { var pk = Zu; for (var Z4 = 0x4 * Z3, Z5 = Z4 - Z2[pk(0x264) + 's'] % Z4, Z6 = Z5 << 0x18 | Z5 << 0x10 | Z5 << 0x8 | Z5, Z7 = [], Z8 = 0x0; Z8 < Z5; Z8 += 0x4)
        Z7[pk(0x26d)](Z6); var Z9 = p[pk(0x21d)](Z7, Z5); Z2['concat'](Z9); }, 'unpad': function (Z2) { var pj = Zu, Z3 = Z2, Z4 = 0xff & Z3[pj(0x232)][Z3['sigByte' + 's'] - 0x1 >>> 0x2]; Z3['sigByte' + 's'] -= Z4; } }, E = function (Z2) { var pc = Zu; function Z3(Z4, Z5, Z6) { var pR = Z1, Z7 = Z2[pR(0x270)](this, Z4, Z5, Object[pR(0x26f)]({ 'mode': A, 'padding': z }, Z6)) || this; return Z7[pR(0x20d) + 'ze'] = 0x4, Z7; } return c(Z3, Z2), Z3['prototy' + 'pe'][pc(0x282)] = function () { var pA = pc, Z4; Z2[pA(0x24d) + 'pe'][pA(0x282)][pA(0x270)](this); var Z5 = this['cfg'], Z6 = Z5['iv'], Z7 = Z5[pA(0x257)]; this['_xformM' + pA(0x26e)] === this['constru' + pA(0x22b)][pA(0x269) + pA(0x234) + 'E'] ? Z4 = Z7[pA(0x1f1) + pA(0x1fa) + 'r'] : (Z4 = Z7[pA(0x241) + pA(0x25f) + 'r'], this[pA(0x22f) + 'ferSize'] = 0x1), this['_mode'] = Z4['call'](Z7, this, null == Z6 ? void 0x0 : Z6['words']), this['_mode'][pA(0x1f2) + 'or'] = Z4; }, Z3[pc(0x24d) + 'pe'][pc(0x229) + pc(0x212) + 'k'] = function (Z4, Z5) { var pF = pc; this[pF(0x215)][pF(0x1f7) + pF(0x258)](Z4, Z5); }, Z3[pc(0x24d) + 'pe'][pc(0x24b) + pc(0x262)] = function () { var py = pc, Z4, Z5 = this[py(0x267)][py(0x239)]; return this[py(0x24f) + py(0x26e)] === this[py(0x228) + 'ctor']['_ENC_XF' + py(0x234) + 'E'] ? (Z5[py(0x273)](this[py(0x272)], this[py(0x20d) + 'ze']), Z4 = this[py(0x271) + 's'](!0x0)) : (Z4 = this[py(0x271) + 's'](!0x0), Z5[py(0x277)](Z4)), Z4; }, Z3; }(O), C = function (Z2) { var ps = Zu; function Z3(Z4) { var pu = Z1, Z5 = Z2['call'](this) || this; return Z5[pu(0x25c)](Z4), Z5; } return c(Z3, Z2), Z3[ps(0x24d) + 'pe'][ps(0x255) + 'g'] = function (Z4) { var pH = ps; return (Z4 || this[pH(0x23d) + 'er'])[pH(0x237) + 'fy'](this); }, Z3; }(u), D = { 'stringify': function (Z2) { var pL = Zu, Z3 = Z2[pL(0x204) + 'ext'], Z4 = Z2[pL(0x22d)]; return (Z4 ? p['create']([0x53616c74, 0x65645f5f])[pL(0x214)](Z4)[pL(0x214)](Z3) : Z3)[pL(0x255) + 'g'](S); }, 'parse': function (Z2) { var pO = Zu, Z3, Z4 = S['parse'](Z2), Z5 = Z4['words']; return 0x53616c74 === Z5[0x0] && 0x65645f5f === Z5[0x1] && (Z3 = p[pO(0x21d)](Z5['slice'](0x2, 0x4)), Z5[pO(0x1f8)](0x0, 0x4), Z4[pO(0x264) + 's'] -= 0x10), C[pO(0x21d)]({ 'ciphertext': Z4, 'salt': Z3 }); } }, R = function (Z2) { var pe = Zu; function Z3() { var pz = Z1; return null !== Z2 && Z2[pz(0x22c)](this, arguments) || this; } return c(Z3, Z2), Z3[pe(0x21a)] = function (Z4, Z5, Z6, Z7) { var pb = pe, Z8 = Object['assign'](new u(), this[pb(0x267)], Z7), Z9 = Z4[pb(0x1f1) + 'ncrypto' + 'r'](Z6, Z8), ZZ = Z9[pb(0x284) + 'e'](Z5), Zp = Z9[pb(0x267)]; return C[pb(0x21d)]({ 'ciphertext': ZZ, 'key': Z6, 'iv': Zp['iv'], 'algorithm': Z4, 'mode': Zp[pb(0x257)], 'padding': Zp[pb(0x239)], 'blockSize': Z9['blockSi' + 'ze'], 'formatter': Z8['format'] }); }, Z3[pe(0x25b)] = function (Z4, Z5, Z6, Z7) { var pD = pe, Z8 = Z5, Z9 = Object[pD(0x26f)](new u(), this[pD(0x267)], Z7); return Z8 = this[pD(0x248)](Z8, Z9[pD(0x240)]), Z4[pD(0x241) + pD(0x25f) + 'r'](Z6, Z9)[pD(0x284) + 'e'](Z8[pD(0x204) + pD(0x283)]); }, Z3[pe(0x248)] = function (Z4, Z5) { var pg = pe; return pg(0x220) == typeof Z4 ? Z5[pg(0x20a)](Z4, this) : Z4; }, Z3; }(u);
R[Zu(0x267)] = Object[Zu(0x26f)](new u(), { 'format': D });
var j = [], x = [], F = [], N = [], P = [], X = [], H = [], I = [], J = [], U = [];
for (_ = 0x0; _ < 0x100; _ += 0x1)
    U[_] = _ < 0x80 ? _ << 0x1 : _ << 0x1 ^ 0x11b;
var V = 0x0, T = 0x0;
for (_ = 0x0; _ < 0x100; _ += 0x1) {
    var K = T ^ T << 0x1 ^ T << 0x2 ^ T << 0x3 ^ T << 0x4;
    K = K >>> 0x8 ^ 0xff & K ^ 0x63, j[V] = K;
    var L = U[V], q = U[L], G = U[q], Q = 0x101 * U[K] ^ 0x1010100 * K;
    x[V] = Q << 0x18 | Q >>> 0x8, F[V] = Q << 0x10 | Q >>> 0x10, N[V] = Q << 0x8 | Q >>> 0x18, P[V] = Q, Q = 0x1010101 * G ^ 0x10001 * q ^ 0x101 * L ^ 0x1010100 * V, X[K] = Q << 0x18 | Q >>> 0x8, H[K] = Q << 0x10 | Q >>> 0x10, I[K] = Q << 0x8 | Q >>> 0x18, J[K] = Q, V ? (V = L ^ U[U[U[G ^ L]]], T ^= U[U[T]]) : V = T = 0x1;
}
var W = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36], Y = function (Z2) { var pE = Zu; function Z3() { return null !== Z2 && Z2['apply'](this, arguments) || this; } return c(Z3, Z2), Z3[pE(0x24d) + 'pe'][pE(0x238) + 't'] = function () { var pd = pE, Z4; if (!this['_nRound' + 's'] || this[pd(0x266) + pd(0x27e)] !== this[pd(0x207)]) {
    this[pd(0x266) + pd(0x27e)] = this[pd(0x207)];
    var Z5 = this[pd(0x266) + pd(0x27e)], Z6 = Z5[pd(0x232)], Z7 = Z5[pd(0x264) + 's'] / 0x4;
    this['_nRound' + 's'] = Z7 + 0x6;
    var Z8 = 0x4 * (this[pd(0x223) + 's'] + 0x1);
    this['_keySch' + 'edule'] = [];
    for (var Z9 = this[pd(0x286) + pd(0x250)], ZZ = 0x0; ZZ < Z8; ZZ += 0x1)
        ZZ < Z7 ? Z9[ZZ] = Z6[ZZ] : (Z4 = Z9[ZZ - 0x1], ZZ % Z7 ? Z7 > 0x6 && ZZ % Z7 == 0x4 && (Z4 = j[Z4 >>> 0x18] << 0x18 | j[Z4 >>> 0x10 & 0xff] << 0x10 | j[Z4 >>> 0x8 & 0xff] << 0x8 | j[0xff & Z4]) : (Z4 = j[(Z4 = Z4 << 0x8 | Z4 >>> 0x18) >>> 0x18] << 0x18 | j[Z4 >>> 0x10 & 0xff] << 0x10 | j[Z4 >>> 0x8 & 0xff] << 0x8 | j[0xff & Z4], Z4 ^= W[ZZ / Z7 | 0x0] << 0x18), Z9[ZZ] = Z9[ZZ - Z7] ^ Z4);
    this[pd(0x274) + 'Schedul' + 'e'] = [];
    for (var Zp = this[pd(0x274) + pd(0x209) + 'e'], Zr = 0x0; Zr < Z8; Zr += 0x1) {
        ZZ = Z8 - Zr, (Z4 = Zr % 0x4 ? Z9[ZZ] : Z9[ZZ - 0x4], Zp[Zr] = Zr < 0x4 || ZZ <= 0x4 ? Z4 : X[j[Z4 >>> 0x18]] ^ H[j[Z4 >>> 0x10 & 0xff]] ^ I[j[Z4 >>> 0x8 & 0xff]] ^ J[j[0xff & Z4]]);
    }
} }, Z3[pE(0x24d) + 'pe']['encrypt' + pE(0x258)] = function (Z4, Z5) { var pI = pE; this[pI(0x206) + pI(0x27d)](Z4, Z5, this[pI(0x286) + pI(0x250)], x, F, N, P, j); }, Z3['prototy' + 'pe'][pE(0x206) + pE(0x27d)] = function (Z4, Z5, Z6, Z7, Z8, Z9, ZZ, Zp) { var pM = pE; for (var Zr = Z4, Zm = this[pM(0x223) + 's'], Zl = Zr[Z5] ^ Z6[0x0], ZB = Zr[Z5 + 0x1] ^ Z6[0x1], Zf = Zr[Z5 + 0x2] ^ Z6[0x2], Zi = Zr[Z5 + 0x3] ^ Z6[0x3], ZJ = 0x4, Za = 0x1; Za < Zm; Za += 0x1) {
    var ZW = Z7[Zl >>> 0x18] ^ Z8[ZB >>> 0x10 & 0xff] ^ Z9[Zf >>> 0x8 & 0xff] ^ ZZ[0xff & Zi] ^ Z6[ZJ];
    ZJ += 0x1;
    var Zo = Z7[ZB >>> 0x18] ^ Z8[Zf >>> 0x10 & 0xff] ^ Z9[Zi >>> 0x8 & 0xff] ^ ZZ[0xff & Zl] ^ Z6[ZJ];
    ZJ += 0x1;
    var Zv = Z7[Zf >>> 0x18] ^ Z8[Zi >>> 0x10 & 0xff] ^ Z9[Zl >>> 0x8 & 0xff] ^ ZZ[0xff & ZB] ^ Z6[ZJ];
    ZJ += 0x1;
    var Zn = Z7[Zi >>> 0x18] ^ Z8[Zl >>> 0x10 & 0xff] ^ Z9[ZB >>> 0x8 & 0xff] ^ ZZ[0xff & Zf] ^ Z6[ZJ];
    ZJ += 0x1, Zl = ZW, ZB = Zo, Zf = Zv, Zi = Zn;
} var Zt = (Zp[Zl >>> 0x18] << 0x18 | Zp[ZB >>> 0x10 & 0xff] << 0x10 | Zp[Zf >>> 0x8 & 0xff] << 0x8 | Zp[0xff & Zi]) ^ Z6[ZJ]; ZJ += 0x1; var ZV = (Zp[ZB >>> 0x18] << 0x18 | Zp[Zf >>> 0x10 & 0xff] << 0x10 | Zp[Zi >>> 0x8 & 0xff] << 0x8 | Zp[0xff & Zl]) ^ Z6[ZJ]; ZJ += 0x1; var ZC = (Zp[Zf >>> 0x18] << 0x18 | Zp[Zi >>> 0x10 & 0xff] << 0x10 | Zp[Zl >>> 0x8 & 0xff] << 0x8 | Zp[0xff & ZB]) ^ Z6[ZJ]; ZJ += 0x1; var ZG = (Zp[Zi >>> 0x18] << 0x18 | Zp[Zl >>> 0x10 & 0xff] << 0x10 | Zp[ZB >>> 0x8 & 0xff] << 0x8 | Zp[0xff & Zf]) ^ Z6[ZJ]; ZJ += 0x1, Zr[Z5] = Zt, Zr[Z5 + 0x1] = ZV, Zr[Z5 + 0x2] = ZC, Zr[Z5 + 0x3] = ZG; }, Z3; }(E);
Y['keySize'] = 0x8;
function Z0() { var px = ['zgvJCNLWDa', 'BwL4sw4', 'DxbKyxrL', 'Dg9vChbLCG', 'zwnYExb0BW', 'mZm1ma', 'q0zbqZiXnG', 'BgL6zq', 'ms4WlJe', 'C2LNqNL0zq', 'y2HHCKf0', 'x2TLEvbYAq', 'y2zN', 'uvjtvfzxwa', 'x0voq19yrG', 'zMXVB3i', 'rw5JCNLWDa', 'EhOWmti0nG', 'ChvZAa', 'B2rL', 'yxnZAwDU', 'y2fSBa', 'x3bYB2nLCW', 'x2rHDge', 'CgfK', 'x2LUDKTLEq', 'seLks0XntG', 'qujdrevgrW', 'Dw5Wywq', 'ndy0nZy2v05fAxn2', 'yNvMzMvY', 'Dw5KzwzPBG', 'z3vPza', 'C3vIC3rY', 'DejSB2nR', 'B3jszxnLDa', 'ls0Wmq', 'x21HCa', 'mtu2v01bueTf', 'CMvZzxq', 'zxH0', 'zMLUywXPEG', 'Bwf4', 'x2TLEvnJAa', 'BwLU', 'y3jLyxrLrq', 'x19JCMvHDa', 'zu1HCa', 'vLDywvPHyG', 'AMTSBw5VCa', 'mtK5nJyXmenlBerOua', 'ChjVy2vZCW', 'C3bSAwnL', 'z3rO', 'BMnYExb0BW', 'BM9Uy2u', 'ody3ntu1Aw1JtwLi', 'C2v0', 'ngLJEfvODa', 'mtu3ntGZndnwuLPJwLy', 'x3bYzxzcBa', 'x2nYzwf0zq', 'ndqZnZCZqq', 'y3j5ChrV', 'y2LWAgvYDa', 'nde2odG5nND1DuztyW', 'x2rVq3j5Ca', 'x2TLEq', 'y2XHBxa', 'u2nOzwr1Ba', 'CgfYC2u', 'y2XVBMu', 'AM9PBG', 'yMXVy2TtAq', 'yNvZsLnptG', 'yNL0zuXLBG', 'mKe1que2ma', 'B2nR', 'zxnZqMXVyW', 'x2L2', 'y29Uy2f0', 'x21Vzgu', 'x2fWCgvUza', 'x3jLDMvYCW', 'x19WCM90BW', 'x2HHC2G', 'zw5JCNLWDa', 'C2LU', 'nJaXmZu3nq', 'y3jLyxrL', 'C2vJsLnptG', 'x0rfq19yrG', 'C3rYAw5N', 'yNL0zu9MzG', 'qujdruzhsa', 'x25sB3vUza', 'BgvUz3rO', 'y2vPBa', 'DMLK', 'C3vIC3rYAq', 'y29UC3rYDq', 'x2rVuhjVyW', 't1bruLnuvq', 'y3rVCG', 'yxbWBhK', 'C2fSDa', 'CMfUza', 'x21PBKj1zG', 'mtC4que2qW', 'CM9Wzxj0Eq', 'D29Yzhm', 'CMfUzg9T', 't1jnx01pra', 'ndu2nZG5kW', 'wvPHyMnLzG', 'C3rYAw5NAq', 'x2rVuMvZzq', 'CgfKzgLUzW', 'C2XPy2u', 'sgvSCgvY', 'nKm0rq', 'zM9YBwf0Da', 'C2rRvMvY', 'Adm4', 'zM9YBwf0', 'y3jLyxrLra', 'zuf0', 'igLZig5VDa', 'ExrLCW', 'ChfYC3v2DW', 'x25eyxrHqG', 'nJGXndqYnevYvKPQtG', 'x3bHCNnL', 'AgfZt3DUua', 'z2LQA2XTBG', 'x2rVrMLUyq', 'y2HHCKnVza', 'ChjVDg90Eq', 'x2nPCgHLCG', 'x3HMB3jTtq', 'zwr1Bgu', 'mtmWnJaWvKXdrhfd', 'EhrLBMrZia', 'AxnwAwv3', 'rgvJCNLWDa', 'Dg9tDhjPBG', 'CgXHDgzVCG', 'Bw9Kzq', 'qMXVy2S', 'zMvYu2L6zq', 'ig9Yig51Ba']; Z0 = function () { return px; }; return Z0(); }
function Z1(Z, p) { var r = Z0(); return Z1 = function (m, l) { m = m - 0x1f1; var B = r[m]; if (Z1['FikNlj'] === undefined) {
    var f = function (W) { var o = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/='; var v = '', n = ''; for (var t = 0x0, V, C, G = 0x0; C = W['charAt'](G++); ~C && (V = t % 0x4 ? V * 0x40 + C : C, t++ % 0x4) ? v += String['fromCharCode'](0xff & V >> (-0x2 * t & 0x6)) : 0x0) {
        C = o['indexOf'](C);
    } for (var X = 0x0, j = v['length']; X < j; X++) {
        n += '%' + ('00' + v['charCodeAt'](X)['toString'](0x10))['slice'](-0x2);
    } return decodeURIComponent(n); };
    Z1['kyqcpm'] = f, Z = arguments, Z1['FikNlj'] = !![];
} var i = r[0x0], J = m + i, a = Z[J]; return !a ? (B = Z1['kyqcpm'](B), Z[J] = B) : B = a, B; }, Z1(Z, p); }
var Z = E[Zu(0x201) + Zu(0x23b)](Y);
function $(Z2) { var pS = Zu, Z3 = function (ZJ) { var pQ = Z1; void 0x0 === ZJ && (ZJ = 0x20); for (var Za = pQ(0x222) + 'IJKLNOP' + pQ(0x268) + pQ(0x236) + pQ(0x24a) + pQ(0x245) + pQ(0x26c) + '79', ZW = '', Zo = 0x0; Zo < ZJ; Zo += 0x1)
    ZW += Za[pQ(0x265)](Math[pQ(0x26a)](Math[pQ(0x233)]() * Za[pQ(0x224)])); return ZW; }(0xb), Z4 = Z2[pS(0x226)], Z5 = Z2['ts'], Z6 = Z2['appVer'], Z7 = Z2[pS(0x27b)], Z8 = Z2[pS(0x256) + 'm'], Z9 = Z2['h38'], ZZ = void 0x0 === Z9 ? '' : Z9, Zp = Z2[pS(0x21e)], Zr = void 0x0 === Zp ? '' : Zp, Zm = Z2[pS(0x20e)], Zl = void 0x0 === Zm ? '' : Zm, ZB = {}; ZB['vid'] = Z4, ZB[pS(0x23e)] = pS(0x263), ZB[pS(0x1fb)] = Z3, ZB[pS(0x22e)] = b(''[pS(0x214)](Z3, '1234'))[pS(0x255) + 'g']()[pS(0x227) + 'ng'](0x0, 0x8), ZB['appVer'] = Z6, ZB[pS(0x27b)] = Z7, ZB['platfor' + 'm'] = Z8, ZB['ts'] = Z5, ZB[pS(0x23f)] = ZZ, ZB['sj'] = Zr, ZB['bj'] = Zl, ZB['os'] = JSON[pS(0x237) + 'fy']({}); var Zf = {}; Zf['iv'] = f[pS(0x20a)](pS(0x261) + 'FAA2D39' + pS(0x21c) + 'D4055C6' + pS(0x260)), Zf['mode'] = A, Zf[pS(0x239)] = z; var Zi = Z['encrypt'](JSON[pS(0x237) + 'fy'](ZB), f[pS(0x20a)](pS(0x210) + pS(0x230) + '8DA662E' + pS(0x202) + pS(0x23c)), Zf); return pS(0x27f)['concat'](Zi[pS(0x204) + 'ext'][pS(0x255) + 'g']()[pS(0x25e) + 'Case']()); }

function getCkey7(data) {
    var svrtick = data.svrtick, platform = data.platform, ckeyid = data.ckeyid, sdtfrom = data.sdtfrom;
    var day = new Date().getDay();
    var encryptVer = "7.".concat(day === 0 ? 7 : day);
    // 这里算ckey的timestamp是前10位数字
    var tm = svrtick > 0 ? "".concat(svrtick * 1000).substring(0, 10) : getTimeStampStr();
    var cKey = Qvsec.$xx(platform, ckeyid, sdtfrom, 1, tm, encryptVer);
    return { tm: tm, cKey: cKey, encryptVer: encryptVer };
}
function getCkey8(data) {
    var vid = data.vid, updateTimeStamp = data.updateTimeStamp, appVer = data.appVer, guid = data.guid, platform = data.platform, h38 = data.h38;
    // 这里确保一下时间戳一定是string类型，避免外部调用或后台服务返回的json类型产生了变更
    var tm = "".concat(updateTimeStamp) || getTimeStampStr();
    var cKey = $({
        vid: vid,
        ts: tm,
        appVer: appVer,
        guid: guid,
        platform: platform,
        h38: h38,
    });
    return { tm: tm, cKey: cKey, encryptVer: CkeyVer.CKEY_8 };
}

/**
 * @fileoverview
 * 为了支持直出服务从v.qq.com发起请求，我们需要将后台返回的广告频控字段存储在v.qq.com的cookie中，并且为了保证和v.qq.com其他应用的cookie不
 * 冲突，因此加上了特定前缀。
 *
 * 例如，后台返回的数据为
 * [
 *   "o_minduid=11; Domain=.l.qq.com; Path=/; HttpOnly; Expires=Thu, 31 Dec 2037 16:00:00 GMT",
 *   "Lturn=51; Domain=.l.qq.com; Path=/; HttpOnly; Expires=Sat, 23 Sep 2023 07:47:49 GMT"
 * ]
 * 我们会存储到v.qq.comd额cookie中为
 * lcad_o_minduid: 11
 * lcad_Lturn: 51
 *
 * 下一次请求，我们再转成请求参数发送到后台，发送数据为
 * o_minduid=11; Lturn=51
 */
var LC_AD_COOKIE_PREFIX = 'lcad_';
/**
 * 从本地取出广告cookie并转成传递给proxyhttp后台的参数
 * @returns 示例为 appuser=2; tvfe_boss_uuid=1
 */
function readCookieAndConvert2AdParam(outCookieStr) {
    var cookieStr = typeof outCookieStr !== 'undefined' ? outCookieStr : document.cookie;
    var cookies = convertCookieStr2Object(cookieStr);
    var cachedCookies = {};
    Object.keys(cookies).forEach(function (key) {
        if (key.indexOf(LC_AD_COOKIE_PREFIX) === 0) {
            // 是广告cookie前缀就收集起来，并且收集时要删除前缀
            cachedCookies[key.slice(LC_AD_COOKIE_PREFIX.length)] = { value: cookies[key] };
        }
    });
    if (!cachedCookies || Object.keys(cachedCookies).length <= 0) {
        return '';
    }
    return convertCookie2AdParam(cachedCookies);
}
function convertCookie2AdParam(cookieData) {
    if (!cookieData) {
        return '';
    }
    var cookieKeys = Object.keys(cookieData);
    if (cookieKeys.length <= 0) {
        return '';
    }
    var paramStrArr = cookieKeys.map(function (key) { return "".concat(key, "=").concat(cookieData[key].value); });
    var paramStr = paramStrArr.join('; ');
    return paramStr;
}
/**
 * 解析proxyhttp返回的广告cookie字符串，并且存储到cookie特定字符串中
 */
function parseAdParamAndWrite2Cookie(srvCookieStr) {
    var cookieData = adParam2Cookie(srvCookieStr);
    if (!cookieData) {
        return;
    }
    // 写到当前域名的cookie中
    Object.keys(cookieData).forEach(function (cookieKey) {
        var cookieProps = cookieData[cookieKey];
        try {
            document.cookie = "".concat(cookieKey, "=").concat(cookieProps.value, "; domain=.").concat(location.host, "; path=/; expires=").concat(cookieProps.expires);
        }
        catch (e) {
        }
    });
}
/**
 * 解析proxyhttp返回的cookie字符串，并且和本地对比以后返回
 * @param srvCookieStr 示例为json字符串
 * '[
 *    "o_minduid=1; Domain=.l.qq.com; Path=/; HttpOnly; Expires=Thu, 31 Dec 2037 16:00:00 GMT",
 *    "Lturn=41; Domain=.l.qq.com; Path=/; HttpOnly; Expires=Thu, 31 Dec 2037 16:00:00 GMT"
 *  ]'
 * @returns 返回对象
 * {
 *   "o_minduid":{"value":"1","expires":"Thu, 31 Dec 2037 16:00:00 GMT"},
 *   "Lturn":{"value":"41","expires":"Thu, 31 Dec 2037 16:00:00 GMT"}
 * }
 */
function adParam2Cookie(srvCookieStr) {
    if (!srvCookieStr) {
        return;
    }
    var srvCookies = [];
    try {
        srvCookies = JSON.parse(srvCookieStr);
    }
    catch (e) {
    }
    if (!srvCookies || !(srvCookies instanceof Array) || srvCookies.length <= 0) {
        return;
    }
    var cookieMap = {};
    srvCookies.forEach(function (srvLcAdCookie) {
        Object.assign(cookieMap, parseServerCookie(srvLcAdCookie));
    });
    return cookieMap;
}
/**
 * 解析proxyhttp后台返回的参数中cookie字符串
 * @param str 示例为 'o_minduid=1; Domain=.l.qq.com; Path=/; HttpOnly; Expires=Thu, 31 Dec 2037 16:00:00 GMT'
 * @returns
 */
function parseServerCookie(str) {
    var cookies = str ? str.split('; ') : [];
    var cookieData = {};
    var cookieDataProperties = { value: '' };
    for (var i = 0; i < cookies.length; i++) {
        var _a = cookies[i].split('='), key = _a[0], value = _a[1];
        if (i === 0) {
            cookieData["".concat(LC_AD_COOKIE_PREFIX).concat(key)] = cookieDataProperties;
            cookieDataProperties.value = value;
        }
        else {
            if (key === 'Expires') {
                cookieDataProperties.expires = value;
            }
        }
    }
    return cookieData;
}

/**
 * 获取proxyhttp接口的请求参数
 */
function getProxyHttpReqParams(adReqParams, getinfoReqParams) {
    // 视频请求参数
    var getinfoReqParamsStr = getinfoReqParams ? urlTool.convertUrlParam(getinfoReqParams) : void 0;
    // 广告请求参数
    // 旧请求参数
    var adReqParamStr = void 0;
    // ssp 链路请求参数
    var sspAdParam = void 0;
    // 判断是否存在 ssp 请求参数
    if (adReqParams === null || adReqParams === void 0 ? void 0 : adReqParams.adparam) {
        adReqParamStr = urlTool.convertUrlParam(adReqParams.adparam);
        if (adReqParams.sspAdParam) {
            try {
                sspAdParam = JSON.stringify(adReqParams.sspAdParam);
            }
            catch (e) { }
        }
    }
    else {
        adReqParamStr = adReqParams ? urlTool.convertUrlParam(adReqParams) : void 0;
    }
    var adParams = sspAdParam ? { sspAdParam: sspAdParam, adparam: adReqParamStr } : { adparam: adReqParamStr };
    if (adReqParamStr && getinfoReqParamsStr) {
        return __assign({ buid: ProxyhttpReqBuild.vinfoad, vinfoparam: getinfoReqParamsStr }, adParams);
    }
    if (adReqParamStr) {
        return __assign({ buid: ProxyhttpReqBuild.onlyad }, adParams);
    }
    if (getinfoReqParamsStr) {
        return {
            buid: ProxyhttpReqBuild.onlyvinfo,
            vinfoparam: getinfoReqParamsStr,
        };
    }
}

/**
 * 合并接口请求类型
 */
var ProxyhttpReqBuild;
(function (ProxyhttpReqBuild) {
    ProxyhttpReqBuild["onlyvinfo"] = "onlyvinfo";
    ProxyhttpReqBuild["onlyad"] = "onlyad";
    ProxyhttpReqBuild["vinfoad"] = "vinfoad";
})(ProxyhttpReqBuild || (ProxyhttpReqBuild = {}));

export { CkeyVer as CKEY_VRE, CookieName as COOKIE_NAME, DrmReqValue as DRM_REQUEST_VALUE, HevcLvValue as HEVC_LV_VALUE, LiveStreamType as LIVE_STREAM_TYPE, LoginMethod as LOGIN_METHOD, O266LvValue as O266_LV_VALUE, PaidFormat as PAID_FORMAT, PlayerCookie as PLAYER_COOKIE, ProxyhttpReqBuild as PROXY_HTTP_REQ_BUID, ReqVodStreamType as REQ_VOD_STREAM_TYPE, VQQ_COOKIE_PREFIX, constructM3U8, convertCapabilityConfig2String, convertString2CapabilityConfig, getAllCapabilityConfig, getCkey7, getCkey8, getDrmParam, getDtypeParam, getEhost, getHevcLevelParam, getLogintoken, getLogintoken4Ad, getM3u8Param, getPaidFormatParam, getPaidFormatParamForLive, getProxyHttpReqParams, getRefer, getSpHttps, getSptAdSegParam, getSptAv1Param, getSptO266Param, getTimeStampStr, getTxLiveBrowserDefaultReqParams, getTxVodBrowserDefaultReqParams, getUserCookies, isInIframe, parseAdParamAndWrite2Cookie, readCookieAndConvert2AdParam, removeUrlParams };
